import request from '@/utils/request'

export function GetScanResult(datas) {
  return request({
    url: '/api/VideoUpload/GetScanResult',
    method: 'get',
    data: {
      qrCodeGuid: datas,
    }
  })
}
export function GetSecretId(datas) {
  return request({
    url: '/api/VideoUpload/GetSecretId',
    method: 'get',
    data: datas
  })
}
export function SaveVUInfoRequest(datas) {
  return request({
    url: '/api/VideoUpload/SaveVUInfoRequest',
    method: 'post',
    data: datas
  })
}

export function GenerateShortUrl(datas) {
  return request({
    url: '/api/Func/GenerateShortUrl',
    method: 'get',
    data: {url:datas}
  })
}